import React from "react";
import { ReactComponent as CloseIcon } from "../../../assets/images/common/closeIcon.svg";
import { SVGSuccess } from "../../Icons/Icons";
import {
  ConfirmIconContainer,
  ConfirmIconItem,
  Circle,
  LogoContainer,
  LogoText,
  StyledNewLogo,
  CloseButton,
} from "../styles";

export const ConfirmationAnimation = () => (
  <ConfirmIconContainer>
    <ConfirmIconItem>
      <SVGSuccess height="170" width="170" />
    </ConfirmIconItem>
    <Circle delay="-2s" />
    <Circle delay="-1s" />
    <Circle delay="1s" />
  </ConfirmIconContainer>
);

export const CloseButtonComponent = ({ onClose }) => (
  <CloseButton onClick={onClose}>
    <CloseIcon height={15} width={15} stroke={"#808080"} />
  </CloseButton>
);

export const Logo = ({ isHidden }) => {
  if (isHidden) {
    return <LogoContainer />;
  }

  return (
    <LogoContainer>
      <LogoText>Powered By</LogoText>
      <StyledNewLogo />
    </LogoContainer>
  );
};
